
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#6C6C6C"}},[_c('path',{attrs:{"d":"M13.998 2.933a.264.264 0 00-.078-.188L11.193.078A.272.272 0 0011 .002V0H2.818A.81.81 0 002 .8v14.4c0 .442.366.8.818.8h10.364a.81.81 0 00.818-.8V2.933h-.002zM11.273.91l1.796 1.757h-1.524a.27.27 0 01-.272-.267V.91zm2.181 14.29a.27.27 0 01-.272.267H2.818a.27.27 0 01-.273-.267V.8a.27.27 0 01.273-.267h7.91V2.4c0 .442.366.8.818.8h1.909v12z"}}),_c('path',{attrs:{"d":"M4.728 7.2a.81.81 0 00-.818.8c0 .442.366.8.818.8a.81.81 0 00.819-.8.81.81 0 00-.819-.8zm0 1.067A.27.27 0 014.456 8a.27.27 0 01.272-.266c.15 0 .273.119.273.266a.27.27 0 01-.273.267zM12.091 7.733H6.637v.534h5.454v-.534zM4.728 4.533a.81.81 0 00-.818.8c0 .442.366.8.818.8a.81.81 0 00.819-.8.81.81 0 00-.819-.8zm0 1.067a.27.27 0 01-.272-.267.27.27 0 01.272-.266c.15 0 .273.119.273.266a.27.27 0 01-.273.267zM12.091 5.067H6.637V5.6h5.454v-.533zM4.728 9.867a.81.81 0 00-.818.8c0 .441.366.8.818.8a.81.81 0 00.819-.8.81.81 0 00-.819-.8zm0 1.066a.27.27 0 01-.272-.266.27.27 0 01.272-.267c.15 0 .273.12.273.267a.27.27 0 01-.273.266zM12.091 10.4H6.637v.533h5.454V10.4zM4.728 12.533a.81.81 0 00-.818.8c0 .442.366.8.818.8a.81.81 0 00.819-.8.81.81 0 00-.819-.8zm0 1.067a.27.27 0 01-.272-.267.27.27 0 01.272-.267c.15 0 .273.12.273.267a.27.27 0 01-.273.267zM12.091 13.067H6.637v.533h5.454v-.533z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2)","d":"M0 0h12v16H0z"}})])])])
          )
        }
      }
    